<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('edit_group_name') }} </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div>
                <label class="fw-400">{{ __('group_name') }}:&nbsp</label>
                <input type="text" name="page" class="max-w-200 form-control" v-model="groupName"
                       style="">
                <span class="help-block text-danger" v-if="anyError">{{ anyError }}</span>
            </div>
        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col white-space-no-wrap" v-if="!anyError">
                    <button type="button" class="btn btn-primary" @click="saveGroupName()">{{__('save')}}</button>
                </div>
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('close')}}</button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
export default {
    name: "EditGroupNameModal",
    data: function () {
        return {
            visible: false,
            groupName:'',
            type:'',
            oldGroupName:''
        }
    },
    props:{
        contractorGroups: {
            type: Array
        },
        itemGroups: {
            type: Array
        },

    },
    methods: {
        saveGroupName() {
            if (!this.anyError) {
                const index = this.currentGroup.findIndex(group => group.name === this.oldGroupName);
                if (index !== -1) {
                    const updatedGroup = { ...this.currentGroup[index], name: this.groupName };
                    this.$set(this.currentGroup, index, updatedGroup);
                    this.visible = false;
                }

            }
        },
    },
    computed:{
        currentGroup() {
            return this.type === 'contractors' ? this.contractorGroups : this.itemGroups;
        },
        anyError() {
            const groups = this.type === 'contractors' ? this.contractorGroups : this.itemGroups;
            const groupNames = groups.map(group => group.name);

            // Sprawdzanie długości i unikalności nazw
            const isLengthValid = this.groupName.length < 32;
            const isDuplicate = groupNames.filter(name => name !== this.oldGroupName && name === this.groupName).length > 0;

            // Zwracanie odpowiedniego błędu
            if (!isLengthValid) {
                return this.__("group_name_length_error");
            } else if (isDuplicate) {
                return this.__("group_name_unique_error");
            } else {
                return null; // Brak błędów
            }
        },
    }
}
</script>

<style scoped>

</style>
